module.exports = __webpack_public_path__ + "static/media/gb-sct.c0e631f7.webp";